import { IxSearchBar } from './IxSearchBar.js';

window.customElements.define('ix-search-bar', IxSearchBar);
